import moment from 'moment';
import { setPreventUnload } from 'flow/actions/app-actions';
import Icon from 'flow/components/ui-components/Icon';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { Message } from 'flow/types/Chats';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import { extractName, getAttachmentLink } from 'flow/utils';
import ImagePreviewBar from './ImagePreviewBar';

interface Props {
    image: TypedMap<Message>;
    sessionKey: ChatSessionKey;
    visible: boolean;
}

const ImagePreviewTopBar = ({ image, sessionKey, visible }: Props) => {
    const { i18next } = useAppContext();
    const { closeModal } = useModal();

    const sent = image.get('sent');
    const attachment = image.get('attachment');

    return (
        <ImagePreviewBar visible={visible}>
            <div className="flex h-13 w-full items-center gap-x-2 px-6 text-sm text-white">
                <div className="font-bold">
                    {extractName(
                        image.getIn(['from', 'contact']),
                        i18next.t('status.unknown'),
                    )}
                </div>
                <div className="flex-1">
                    <time dateTime={sent}>{moment(sent).format('HH:mm')}</time>
                </div>
                <a
                    className="focus-ring"
                    href={getAttachmentLink(sessionKey, attachment)}
                    download={true}
                    onClick={() => setPreventUnload(true)}
                >
                    <Icon
                        iconKey="download"
                        className="p-0.5 text-white hover:bg-black"
                    />
                    <span className="sr-only">Download</span>
                </a>
                <button
                    type="button"
                    className="focus-ring"
                    onClick={closeModal}
                >
                    <Icon
                        iconKey="close"
                        className="p-0.5 text-white hover:bg-black"
                    />
                    <span className="sr-only">Close</span>
                </button>
            </div>
        </ImagePreviewBar>
    );
};

export default ImagePreviewTopBar;
